export default "__VITE_ASSET__CNs8os3Y__"